import MobileModule from './vuex/index';

let mobile = new MobileModule();

export default mobile;


// WEBPACK FOOTER //
// ./src/common/mobile/index.js